import { useEffect, useState } from 'react';

const WELCOME_DURATION_MS = 30000;
export const WELCOME_BANNER_SESSION_KEY = 'locshark_welcome_until';

export const clearWelcomeBannerSession = () => {
  sessionStorage.removeItem(WELCOME_BANNER_SESSION_KEY);
};

export const useWelcomeBanner = (isReady) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isReady || !localStorage.getItem('token')) {
      setVisible(false);
      return undefined;
    }

    const now = Date.now();
    const storedUntil = Number(sessionStorage.getItem(WELCOME_BANNER_SESSION_KEY));

    if (storedUntil && storedUntil <= now) {
      setVisible(false);
      return undefined;
    }

    const until = storedUntil || now + WELCOME_DURATION_MS;
    if (!storedUntil) {
      sessionStorage.setItem(WELCOME_BANNER_SESSION_KEY, String(until));
    }

    setVisible(true);
    const timer = setTimeout(() => setVisible(false), Math.max(0, until - now));
    return () => clearTimeout(timer);
  }, [isReady]);

  return visible;
};
